module.exports = __webpack_public_path__ + "static/media/calculadora.4cb46c2e.png";